function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 96,
    viewBox: "0 0 136 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10185"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10184"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8943",
    transform: "translate(41.739 92.323)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h8.897v.086H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8944",
    transform: "translate(0 91.396)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h18.512v.086H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8945",
    transform: "translate(32.391 95.502)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h9.006v.086H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8946",
    transform: "translate(70.411 94.927)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h13.287v.086H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8947",
    transform: "translate(86.742 94.927)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.658v.086H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8948",
    transform: "translate(117.33 93.483)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h18.669v.086H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46231",
    d: "M111.93 158.67h25.321a1.94 1.94 0 0 1 1.94 1.94v74.616H110v-74.619a1.94 1.94 0 0 1 1.93-1.937z",
    transform: "translate(-90.31 -146.16)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8949",
    transform: "translate(22.105 17.034)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8950",
    transform: "translate(42.691 17.034)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8951",
    transform: "translate(28.965 17.034)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8952",
    transform: "translate(35.831 17.034)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8953",
    transform: "translate(22.105 30.262)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8954",
    transform: "translate(42.691 30.262)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8955",
    transform: "translate(28.965 30.262)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8956",
    transform: "translate(35.831 30.262)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8957",
    transform: "translate(22.105 43.491)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8958",
    transform: "translate(42.691 43.491)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8959",
    transform: "translate(28.965 43.491)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8960",
    transform: "translate(35.831 43.491)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8961",
    transform: "translate(22.105 56.72)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8962",
    transform: "translate(42.691 56.72)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8963",
    transform: "translate(28.965 56.72)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8964",
    transform: "translate(35.831 56.72)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8965",
    transform: "translate(22.105 69.948)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8966",
    transform: "translate(42.691 69.948)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8967",
    transform: "translate(28.965 69.948)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8968",
    transform: "translate(35.831 69.948)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.764v8.38H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46232",
    d: "M375 179h18.135a1.577 1.577 0 0 1 1.577 1.577V248.6H373.44v-68.019A1.578 1.578 0 0 1 375 179z",
    transform: "translate(-263.606 -159.533)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8969",
    transform: "translate(112.53 23.58)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8970",
    transform: "translate(118.767 23.58)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8971",
    transform: "translate(125.006 23.58)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8972",
    transform: "translate(112.53 35.607)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8973",
    transform: "translate(118.767 35.607)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8974",
    transform: "translate(125.006 35.607)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8975",
    transform: "translate(112.53 47.635)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8976",
    transform: "translate(118.767 47.635)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8977",
    transform: "translate(125.006 47.635)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8978",
    transform: "translate(112.53 59.659)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8979",
    transform: "translate(118.767 59.659)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8980",
    transform: "translate(125.006 59.659)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8981",
    transform: "translate(112.53 71.687)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8982",
    transform: "translate(118.767 71.687)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8983",
    transform: "translate(125.006 71.687)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h3.422v7.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46233",
    d: "M252.255 122.11h29.458a2.255 2.255 0 0 1 2.255 2.255v86.811H250v-86.811a2.255 2.255 0 0 1 2.255-2.255z",
    transform: "translate(-182.406 -122.11)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8984",
    transform: "translate(70.413 5.263)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8985",
    transform: "translate(94.363 5.263)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8986",
    transform: "translate(78.398 5.263)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8987",
    transform: "translate(86.379 5.263)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8988",
    transform: "translate(70.413 20.654)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8989",
    transform: "translate(94.363 20.654)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8990",
    transform: "translate(78.398 20.654)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8991",
    transform: "translate(86.379 20.654)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8992",
    transform: "translate(70.413 36.045)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8993",
    transform: "translate(94.363 36.045)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8994",
    transform: "translate(78.398 36.045)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8995",
    transform: "translate(86.379 36.045)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8996",
    transform: "translate(70.413 51.436)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8997",
    transform: "translate(94.363 51.436)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8998",
    transform: "translate(78.398 51.436)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8999",
    transform: "translate(86.379 51.436)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9000",
    transform: "translate(70.413 66.824)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9001",
    transform: "translate(94.363 66.824)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9002",
    transform: "translate(78.398 66.824)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9003",
    transform: "translate(86.379 66.824)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h4.38v9.749H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9004",
    transform: "translate(48.881 31.898)",
    style: {
      fill: "#e6e6e6"
    },
    d: "M0 0h18.714v57.168H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9005",
    transform: "translate(101.566 38.02)",
    style: {
      fill: "#e6e6e6"
    },
    d: "M0 0h8.267v51.046H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46234",
    d: "M78.487 325.867H62.11V302l16.377-5.54z",
    transform: "translate(-58.807 -236.801)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.345,
    cy: 3.873,
    rx: 66.345,
    ry: 3.873,
    transform: "translate(1.25 84.796)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.847 37.034)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46238",
    d: "M184.119 339.63a7.318 7.318 0 1 0 0 14.637h1.465V339.63z",
    transform: "translate(-147.099 -302.233)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46239",
    d: "M339.929 339.63a7.318 7.318 0 1 0 0 14.637h1.461V339.63z",
    transform: "translate(-249.594 -302.233)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 852",
    cx: 7.316,
    cy: 7.316,
    r: 7.316,
    transform: "translate(58.862 37.397)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 853",
    cx: 7.316,
    cy: 7.316,
    r: 7.316,
    transform: "translate(5.543 37.397)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9006",
    transform: "translate(46.362 5.927)",
    style: {
      fill: "#b0bec5"
    },
    d: "M0 0h27.761v35.272H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9007",
    transform: "translate(46.362 5.927)",
    style: {
      opacity: 0.2
    },
    d: "M0 0h27.761v35.272H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9008",
    transform: "rotate(-40.45 71.15 -130.786)",
    style: {
      fill: "#b0bec5"
    },
    d: "M0 0h.342v1.704H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9009",
    transform: "rotate(-40.45 61.72 -127.32)",
    style: {
      fill: "#b0bec5"
    },
    d: "M0 0h.342v5.307H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46240",
    d: "M306.62 282.928h34.48v-15.305a4.77 4.77 0 0 0-1.143-3.1l-10.727-12.606a12.11 12.11 0 0 0-9.222-4.257H306.62z",
    transform: "translate(-232.497 -241.734)",
    style: {
      fill: "#b0bec5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46241",
    d: "M323.13 272.734v-12.969a2.125 2.125 0 0 1 2.128-2.125h3.3a11.942 11.942 0 0 1 9.088 4.2l8.113 9.519a2.115 2.115 0 0 1 .506 1.369 2.128 2.128 0 0 1-2.125 2.128h-18.882a2.128 2.128 0 0 1-2.128-2.118z",
    transform: "translate(-243.358 -248.299)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46242",
    d: "M396.658 330.985H392.4a1.321 1.321 0 0 1-1.153-1.964l.719-1.287a1.321 1.321 0 0 1 1.153-.684h3.538z",
    transform: "translate(-288.057 -293.958)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9010",
    transform: "translate(.897)",
    style: {
      fill: "#b0bec5"
    },
    d: "M0 0h67.098v41.195H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9011",
    transform: "translate(.897)",
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "M0 0h67.098v41.195H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9012",
    transform: "translate(19.066 34.916)",
    style: {
      opacity: 0.5,
      fill: "#b0bec5"
    },
    d: "M0 0h11.419v2.481H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9013",
    transform: "translate(.897 34.916)",
    style: {
      opacity: 0.5,
      fill: "#b0bec5"
    },
    d: "M0 0h3.134v2.481H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9014",
    transform: "translate(.897)",
    style: {
      opacity: 0.4,
      fill: "#b0bec5"
    },
    d: "M0 0h23.179v41.195H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9015",
    transform: "translate(10.939)",
    style: {
      opacity: 0.4,
      fill: "#b0bec5"
    },
    d: "M0 0h.373v41.195H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 9016",
    width: 109.497,
    height: 2.857,
    rx: 1.429,
    transform: "translate(0 41.195)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 854",
    cx: 7.316,
    cy: 7.316,
    r: 7.316,
    transform: "translate(84.488 37.397)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 855",
    cx: 4.708,
    cy: 4.708,
    r: 4.708,
    transform: "translate(87.095 40.004)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 856",
    cx: 7.316,
    cy: 7.316,
    r: 7.316,
    transform: "translate(31.169 37.397)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 857",
    cx: 4.708,
    cy: 4.708,
    r: 4.708,
    transform: "translate(33.777 40.004)",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVehicle);
export default __webpack_public_path__ + "static/media/noVehicle.8dfce585b91ca50a9832f17ada66294b.svg";
export { ForwardRef as ReactComponent };